import { get } from 'core/communcation/api';

export const getDevices = async () => {
    return get('devices/devices');
};
